'use strict';

export default {
  rulesAdmin: {
    general: {
      title: 'Éditeur de règles',
      rules: 'Règles',
      ruleName: 'Nom de la règle',
      untitled: 'sans titre',
      twoFields: 'Vous devez avoir 2+ champs pour pouvoir ajouter des règles.',
      addNewRule: 'Ajouter une règle',
      targets: 'Cibles(s)',
      conditions: 'Condition(s)',
      and: 'ET',
      or: 'OU',
      addNewTarget: 'Ajouter une cible',
      save: 'Sauvegarder',
      cancel: 'Annuler',
    },
    conditions: {
      lowerThan: 'Plus petit que (<)',
      lowerThanOrEqualTo: 'Plus petit que ou égale à (≤)',
      equal: 'Égale (=)',
      greaterThanEqualTo: 'Plus grand que ou égale à (≥)',
      greaterThan: 'Plus grand que (>)',
      isChecked: 'Coché',
      includes: 'Contient',
      isCompleted: 'Est rempli',
    },
    actions: {
      isRequired: 'Est requis',
      isVisible: 'Est visible',
    },
    errors: {
      onSave: 'Une ou plusieurs règles ont des erreurs à corriger.',
      validation1: 'Vous ne pouvez pas avoir des conditions utilisant des champs de différentes sections multiples.',
      validation2:
        "Une ou plusieurs de vos cibles utilisent un champ d'une section multiple qui n'est pas la même que les champs des autres cibles ou conditions.",
      validation3:
        "Une de vos cibles utilise un champ qui n'est pas une section multiple. Quand vous avez une condition ou une cible qui utilise un champ d'une section multiple, tous les champs des cibles doivent être de la même section multiple.",
    },
  },
};
